import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter, reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import type { McpTokenRevocation, StartMcpTokenRevocationResult } from "./types";
import { isMcpTokenRevocation, isStartMcpTokenRevocationResult } from "./validators";

export const getMcpTokenRevocation = reactQueryFetcherAdapter(
  "/companies/:company_id/oauth_mcp_settings/revocations/:operation_id",
  (signal: AbortSignal, companyId: string, operationId: string): Promise<McpTokenRevocation> =>
    fetch(
      `/companies/${companyId}/oauth_mcp_settings/revocations/${operationId}`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    ),
  isMcpTokenRevocation
);

export const postMcpTokenRevocation = reactQueryMutationAdapter(
  [],
  async (props: { company_id: string }): Promise<StartMcpTokenRevocationResult> => {
    const operation: unknown = await fetch(
      `/companies/${props.company_id}/oauth_mcp_settings/revoke_tokens`,
      "POST",
      {},
      {},
      { propagateFetchRequestError: false }
    );
    if (!isStartMcpTokenRevocationResult(operation)) {
      throw new Error("Invalid MCP token revocation response");
    }
    return operation;
  }
);
